<template>
    <div style="padding: 0px" class="container-fluid">
        <div style="border: 0px" class="card" v-if="center != null">
            <div style="border: 0px" class="card-body1">
                <div class="col-md-12 text-center" style="height: 100vw; margin-top: 100px" v-if="$route.fullPath == '' || $route.fullPath == '/'">
                    <h3>Welcome</h3>
                    <p>You need to visit on following link.</p>
                    <router-link tag="a" to="/login" class="btn btn-success m-1">Staff Login</router-link>
                    <router-link tag="a" to="/customer/register" class="btn btn-success m-1">Customer Login / Register</router-link>
                </div>
                <router-view></router-view>
            </div>
        </div>
        <div class="selectcenterdiv" v-else>
            <b-card no-body>
                <div class="card-body">
                    <img src="../assets/images/logocentumx.png" alt="" />
                    <p class="text-center">
                        CentumX is an advanced leisure management software, designed to improve the way sport and recreational activities are managed. Our vision is to empower users, providing them
                        with a sweamless and enhanced leisure management experience.
                    </p>
                    <h6 class="text-center mt-5">Select Center</h6>
                    <div class="mt-3" style="display: flex; flex-direction: row; justify-content: space-between; padding-bottom: 2rem">
                        <b-select class="select" v-model="selected_center">
                            <option :value="o" v-for="(o, i) in list" :key="i">{{ o.center_name }}</option>
                        </b-select>
                        <button @click="navigatetologin()" class="btn btn-action m-0 mx-2">Submit</button>
                    </div>
                </div>
                <p class="text-center mt-5 mb-0 p-0">Copyright 2025 centumX</p>
            </b-card>
        </div>
    </div>
</template>

<script>
    import '@/assets/sass/authentication/auth.scss';
    import { mapGetters } from 'vuex';
    import axios from 'axios';

    export default {
        name: 'Home',
        data() {
            return {
                baseurl: this.$appSetting.hostname,
                title: '',
                list: [],
                selected_center: null,
            };
        },
        metaInfo() {
            const ctr = this.title;
            return {
                title: `${ctr}`,
            };
        },
        beforeCreate() {
            const isTestmode = window.location.href.includes('?test=1');

            if (isTestmode) {
                localStorage.removeItem('selected_center');
                document.cookie = 'selected_center=; path=/; max-age=0';
                console.log('selected_center cleared due to ?test=1 in URL (beforeCreate)');
            }
            const currentUrl = window.location.href;

            if (currentUrl.includes('resetpassword')) {
                const parts = currentUrl.split('/');
                const reset_center_Id = parts[parts.length - 1];
                console.log('auth Reset password route detected. Skipping redirects.', reset_center_Id);
                return;
            } else {
                console.log('auth page select center', window.location.href);
                const isTestmode = window.location.href.includes('?test=1');
                console.log('isTestmode auth layout 1', isTestmode);
                const getSelectedCenterIdFromCookie = () => {
                    const cookies = document.cookie.split('; ');
                    const selectedCenterCookie = cookies.find((cookie) => cookie.startsWith('selected_center='));

                    if (!selectedCenterCookie) return null;

                    const encodedValue = selectedCenterCookie.split('=')[1];
                    const decodedValue = decodeURIComponent(encodedValue);

                    try {
                        const selectedCenter = JSON.parse(decodedValue);
                        return selectedCenter.id;
                    } catch (e) {
                        console.error('Error parsing selected_center cookie:', e);
                        return null;
                    }
                };

                const centerId = getSelectedCenterIdFromCookie();
                const token = localStorage.getItem('token');

                // ✅ PRIORITY: If both are missing, go to select center
                if (!centerId && !token) {
                    this.$router.push(isTestmode ? '/selectcenter?test=1' : '/selectcenter').catch(() => {});
                    return;
                }

                // ❌ No token but centerId exists → go to login
                if (!token) {
                    this.$router.push('/login').catch(() => {});
                    return;
                }

                // ✅ If token exists, verify it
                axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
                axios
                    .get('getProfile')
                    .then((res) => {
                        if (res.data.error) {
                            this.$router.push('/login').catch(() => {});
                        } else {
                            this.$store.dispatch('user', res.data.data);

                            if (!centerId) {
                                this.$router.push(isTestmode ? '/selectcenter?test=1' : '/selectcenter').catch(() => {});
                            } else {
                                axios
                                    .get('publicGetCenterDetails/' + centerId)
                                    .then((res) => {
                                        if (!res.data.error) {
                                            this.$store.dispatch('center', res.data.data);
                                        }
                                    })
                                    .catch((err) => {
                                        console.log(err);
                                    });
                            }
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        this.$router.push('/login').catch(() => {});
                    });
            }
        },

        mounted() {
            const isTestmode = window.location.href.includes('?test=1');

            if (isTestmode) {
                localStorage.removeItem('selected_center');
                document.cookie = 'selected_center=; path=/; max-age=0';
                console.log('selected_center cleared due to ?test=1 in URL (created hook)');
            }
            //const isTestmode = window.location.href.includes('?test=1');
            console.log('isTestmode auth layout 2', isTestmode);
            const currentUrl = window.location.href;
            console.log('currentUrl auth layout', currentUrl);
            if (!currentUrl.includes('resetpassword')) {
                if (this.center) {
                    this.$nextTick(() => {
                        this.$router.push(isTestmode ? '/selectcenter?test=1' : '/selectcenter');
                    });
                }
            }
            if (!currentUrl.includes('resetpassword')) {
                this.getallcenterlist();
            }
        },
        watch: {
            $route(to) {
                console.log('to query select center', to);
                if (to.query.test === '1') {
                    // Clear selected_center cookie and localStorage
                    localStorage.removeItem('selected_center');
                    document.cookie = 'selected_center=; path=/; max-age=0';
                    console.log('selected_center cleared due to ?test=1 in URL (watch)');
                }
            },
        },
        methods: {
            getallcenterlist() {
                const isTestmode = window.location.href.includes('?test=1');
                console.log('isTestmode getallcenter selectcenet', isTestmode);
                axios
                    .get(isTestmode ? 'get_all_center?test=1' : 'get_all_center')
                    .then((res) => {
                        if (res.data.error) {
                            console.log(res);
                        } else {
                            console.log(res);
                            this.list = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            },
            navigatetologin() {
                if (this.selected_center) {
                    // Clear previous values just in case
                    localStorage.removeItem('selected_center');
                    document.cookie = `selected_center=; path=/; max-age=0`;

                    // Set new values
                    localStorage.setItem('selected_center', JSON.stringify(this.selected_center));
                    document.cookie = `selected_center=${encodeURIComponent(JSON.stringify(this.selected_center))}; path=/; max-age=${60 * 60 * 24 * 30}`;

                    // Optional: verify cookie
                    const cookies = document.cookie.split('; ').reduce((acc, current) => {
                        const [key, value] = current.split('=');
                        acc[key] = value;
                        return acc;
                    }, {});
                    console.log(cookies['selected_center']);
                    // this.$router.push('/login');
                    window.location.href = '/login';
                } else {
                    this.$bvToast.toast('Please Select Center', {
                        headerClass: 'd-none',
                        bodyClass: 'toast-danger text-center',
                        toaster: 'b-toaster-top-center',
                        autoHideDelay: 3000,
                    });
                }
            },
        },
        computed: {
            ...mapGetters(['center']),
        },
    };
</script>

<style scoped>
    .selectcenterdiv {
        background: linear-gradient(180deg, #0a3ecb 0%, rgba(74, 187, 238, 0.98) 100%) !important;

        height: 100vh;
        img {
            width: 30%;
            margin: 2% 35%;
        }
        .card {
            padding: 4rem 2rem 2rem;
            width: 50%;
            margin: auto;
            height: 100%;
            background-color: white;
            border: none;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            h5 {
                font-weight: 600;
            }
        }
        @media (max-width: 1200px) {
            .card {
                width: 80%;
                height: 100%;
            }
        }
        @media (max-width: 992px) {
            .card {
                width: 70%;
                height: 100%;
            }
        }
        @media (max-width: 768px) {
            .card {
                width: 100%;
                height: 100%;
            }
        }
        @media (max-width: 576px) {
            .card {
                width: 100%;
                height: 100%;
                padding: 10px;
            }
            img {
                width: 50%;
                margin: 20% 25%;
            }
        }
        .select {
            width: 100%;
            margin: auto;
            height: 3rem;
        }
        .card-body {
            padding: 0;
        }
        .btn.btn-action {
            background: linear-gradient(180deg, #0a3ecb 0%, rgba(74, 187, 238, 0.98) 100%) !important;
            box-shadow: none;
            cursor: pointer;
            padding: 5px 8px;
            border-radius: 6px;
            color: #fff !important;
            width: 30%;
        }
    }
</style>
